import { UserForeignKey } from 'common/types/Entities';

import { _request,APIBaseResponse, APIMethod } from '..';

const USERS_PATH_PREFIX = '/users';
const FOREIGN_SYSTEMS_PREFIX = '/foreignsystems';
const USER_FOREIGN_KEYS_PATH_PREFIX = 'userforeignkeys';

export type APIUserProfileForeignSystemsGetListParams = {
    userId: string
};

type APIUserProfileForeignSystemsDeleteParams = {
    userId: string;
    foreignSystemId: string;
}

type APIUserProfileForeignSystemsDeleteResponse = APIBaseResponse<''>

export type APIUserProfileForeignSystemsGetListResponse = APIBaseResponse<Array<UserForeignKey>>;

export type APIUserProfileForeignSystemsPostParams = {
    userId: string;
    foreignSystemId: string;
    foreignKey: string;
}

export type APIUserProfileForeignSystemsPutParams = {
    userId: string;
    foreignSystemId: string;
    foreignKey: string;
}

export const APIUserProfileForeignSystemsGet: APIMethod<APIUserProfileForeignSystemsGetListParams, APIUserProfileForeignSystemsGetListResponse> = params => {
    return _request('GET', `${USERS_PATH_PREFIX}/${params.userId}/${USER_FOREIGN_KEYS_PATH_PREFIX}`);
};

export const APIUserProfileForeignSystemsPost: APIMethod<APIUserProfileForeignSystemsPostParams, APIBaseResponse> = params => (
    _request('POST', `${FOREIGN_SYSTEMS_PREFIX}/${params.foreignSystemId}/${USER_FOREIGN_KEYS_PATH_PREFIX}`, params)
);

export const APIUserProfileForeignSystemsPut: APIMethod<APIUserProfileForeignSystemsPutParams, APIBaseResponse> = params => (
    _request('PUT', `${FOREIGN_SYSTEMS_PREFIX}/${params.foreignSystemId}/${USER_FOREIGN_KEYS_PATH_PREFIX}/${params.userId}`, params)
);

export const APIUserProfileForeignSystemDelete: APIMethod<APIUserProfileForeignSystemsDeleteParams, APIUserProfileForeignSystemsDeleteResponse> = params => (
    _request('DELETE', `${FOREIGN_SYSTEMS_PREFIX}/${params.foreignSystemId}/${USER_FOREIGN_KEYS_PATH_PREFIX}/${params.userId}`)
);
